import React, { FunctionComponent } from "react";
import "./App.css";
import Routes from "./Routes";
import { MuiThemeProvider } from "@material-ui/core";
import { themes } from "@bg/shared/lib/theme";
import { SnackbarProvider } from "notistack";
import { LookupProvider } from "@bg/shared/lib/components/pickers";
import IdleOverlay from "@bg/shared/lib/components/IdleOverlay";
import {
  withAITracking,
  AppInsightsContext,
} from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "./AppInsights";
import { UserManagementWarning } from "./views/Attestations";
import {
  Auth0Provider,
  useAuth0,
} from "@bg/shared/lib/auth/react-auth0-wrapper";

interface AppProps {}

const App: FunctionComponent<AppProps> = () => {
  const { showUserManagementAttestationMessage } = useAuth0();
  return (
    <AppInsightsContext.Provider value={reactPlugin}>
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <LookupProvider>
          <MuiThemeProvider theme={themes.appTheme}>
            <IdleOverlay idleTimeoutSeconds={60 * 60}>
              {showUserManagementAttestationMessage ? (
                <UserManagementWarning />
              ) : (
                <div className="App">
                  <Routes />
                </div>
              )}
            </IdleOverlay>
          </MuiThemeProvider>
        </LookupProvider>
      </SnackbarProvider>
    </AppInsightsContext.Provider>
  );
};

export default withAITracking(reactPlugin, App);
